import { Fragment } from "react";
import { blogPosts, blogPostsBase } from "../../../blogposts";
import { FontPlayfair } from "../fonts/playfair";
import { Article } from "../../app/(core)/writing/_components/Article";

export function RelatedArticles({ postId }) {
  const blogPost = blogPostsBase.find((post) => post.id === postId)!;

  // We want to display a minimum of 3 related articles.
  const relatedPostIds = blogPost.relatedPostIds;
  blogPosts.forEach((post) => {
    if (post.id !== postId) {
      if (relatedPostIds.length < 3) {
        if (!relatedPostIds.find((id) => id === post.id)) {
          relatedPostIds.push(post.id);
        }
      }
    }
  });

  return (
    <>
      <div className="container px-2 mx-auto mb-32">
        <div className="md:px-16 lg:px-32">
          <FontPlayfair>
            <h2 className="text-4xl">Related articles to this</h2>
          </FontPlayfair>
          <div className="my-4 md:my-6 md:px-16">
            <div className="w-full border-b border-black border-opacity-25" />
          </div>
          <div className="space-y-6">
            {relatedPostIds.map((id) => {
              const relatedPost = blogPosts.find((post) => post.id === id)!;

              return (
                <Fragment key={id}>
                  <Article blogPost={relatedPost} />
                </Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
